module.exports = {
	client: require("./lib/client"),
	Client: require("./lib/client")
};
